import { CSSProperties } from 'react';

export const wrapperStyle: CSSProperties = {
  position: 'relative',
  borderRadius: '12px',
  marginLeft: '14px',
  marginRight: '14px'
};

export const titleStyle: CSSProperties = {
  marginLeft: '2px',
  fontSize: '14px',
  marginBottom: '5px',
  fontWeight: 'bold',
  color: 'rgb(136,135,135)'
};

export const titleAfterStyle: CSSProperties = {
  marginRight: '2px',
  fontSize: '14px',
  marginBottom: '5px',
  fontWeight: 'bold',
  color: 'rgb(85 84 84)',
  alignSelf: 'flex-end'
};

export const footerStyle: CSSProperties = {
  marginTop: '5px',
  marginLeft: '12px',
  fontSize: '12px',
  color: '#787878',
  fontWeight: 510,
  alignSelf: 'flex-end'
};
